// services/atualizarCota.ts
// --------------------- Import Global ---------------------
import axios from "axios";
import Globais, { validateToken } from "../../../components/Globais";
// --------------------- Import Interface ---------------------
import { Cota } from "../interfaces/Cota";

export const atualizarCota = async (
  cotaId: number | undefined | null,
  atualizarCota: Cota
) => {
  const Token = validateToken();
  if (Token) {
    const URL = `${Globais.DOMINIOBACK}/cota/${cotaId}`;

    try {
      const response = await axios.put(URL, atualizarCota, {
        headers: { Authorization: Token.AuthStr },
      });
      if (response && response.data) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
    }
  }
};
